import { GraphQLClient } from 'graphql-request';

const endpoint = process.env.REACT_APP_APPSYNC_URL!;
const apiKey = process.env.REACT_APP_APPSYNC_API_KEY!;

if (!endpoint) {
  throw new Error("AppSync URL is missing in environment variables");
}

if (!apiKey) {
  throw new Error("AppSync API Key is missing in environment variables");
}

export const client = new GraphQLClient(endpoint, {
  headers: {
    'x-api-key': apiKey,
  },
});